import { Component, OnInit } from '@angular/core';
import { CommonService } from '../common.service';
import { CookieService } from 'ngx-cookie-service';
import { ReferralsService } from './referrals.service';
import { Router } from '@angular/router';
import { SessionStorageService } from 'ngx-webstorage';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertService } from 'ngx-alerts';

@Component({
  selector: 'app-referrals',
  templateUrl: './referrals.component.html',
  styleUrls: ['./referrals.component.css']
})
export class ReferralsComponent implements OnInit {
 
  referralMail: string;
  referral: any;
  constructor(private  commonService: CommonService,private spinner: NgxSpinnerService, private session: SessionStorageService, private cookieService: CookieService, private referralsService: ReferralsService, private routes: Router, private alertService: AlertService) {
    
   }
  ngOnInit() {
    if(this.session.retrieve('token')){
      this.commonService.tokenValidity().then((res: any) => {
        this.spinner.hide();
        }).catch((err: any) => {     
            this.alertService.danger(err.message);
            this.spinner.hide();
            this.routes.navigate(['/login']);
      });
    }else{      
      this.routes.navigate(['/login']);
    }
    this.spinner.show();
    this.referralsService.getreferralid().then((res: any)  => {
      this.spinner.hide();
      if(res.status){
        this.referralMail = res.qstring;
      }
    }).catch((err: any) => {     
      this.alertService.danger(err.message);
      this.spinner.hide();
    });
    this.referralsService.referrals().then((res: any)  => {
      this.spinner.hide();
      if(res.status == 'Success'){
        this.referral = res.items;
      }
    }).catch((err: any) => {
      this.spinner.hide();
    });
  }


}
